module.exports = __webpack_public_path__ + "img/cancel.26a8b1a2.png";